// @ts-nocheck
import { ref, watch, onMounted, computed } from "vue";
import {  LocalStorage } from 'quasar'
import * as turf from '@turf/turf'
import  pako from 'pako' 
import { useRouter, useRoute } from 'vue-router';
import { AllCodes } from '../assets/SppCodesToNames.json';
import { layerRootNames } from '../assets/MapTiles.json'
import * as M  from 'maplibre-gl';
import { event } from "vue-gtag";
import { domToPng } from 'modern-screenshot'
import pdfFonts from '../assets/vfs_fonts.js';
import pdfMake from 'pdfmake/build/pdfmake';
import { feature } from '@turf/helpers';

pdfMake.vfs = pdfFonts;


//putting the variable outside the function call makes it global
//inside it will create a new instance each time
const appVersion = ref(0);
const releaseDate = ref(null);
const loadingLease = ref(false)
const opacity = ref(80);
const queryParams = ref({});
const polyOffMap = ref(false);
const loading = ref(true);
const querying = ref(false);
const firstPan = ref(true);
const tileLayers = ref(null);
const map = ref(null);
const userPolygon = ref(null);
const activeLayerID = ref(null);
const drawingActive = ref(false);
const draw = ref(null);
const mapLoaded = ref(false);
const mapZoom = ref(null);
const drawZoomWarn = ref(false);
let restorationProjectMarker: M.Marker | null = null;
const restorationProjectHighlightMarkers: M.Marker[] = [];
const mapStyleInfo = ref({}); // an object that stores the layer & attr of currently styled data.  e.g. {layer: FISHSPR, attr: "SP012"}
const clickAttrs = ref([]);
const cellData = ref({});
const dataQuality = ref(false);
const processedData = ref({});
const base64QueryString = ref(null);
const activePane = ref('summary');
const legendObj = ref({content:{}});
const siteNames = ref({1: 'Area 1', 2: 'Area 2', 3: 'Area 3', 4: 'Area 4', 5: 'Area 5', 6: 'Area 6', 7: 'Area 7', 8: 'Area 8', 9: 'Area 9', 10: 'Area 10'});
const activeSpSpotlight = ref(null);
const activeHabSpotlight = ref(null);
const activeCoastalHabitat = ref(null)
const activeSpGroups = ref({"fish" : "all", "mammals" : "all", "birds" : "all", "coastalbirds" : "all"});
const activeFlagType = ref('marineLifeFlags')
const activeFlagValue = ref('habitats')
const showResultTabLabels = ref(true)
const mapNotes = ref([])
const rendering = ref(false)
const firstPanelClicks = ref({1:{"species":true, "features": true, "people" : true, "coastal" : true},
  2:{"species":true, "features": true, "people" : true, "coastal" : true},
  3:{"species":true, "features": true, "people" : true, "coastal" : true},
  4:{"species":true, "features": true, "people" : true, "coastal" : true},
  5:{"species":true, "features": true, "people" : true, "coastal" : true},
  6:{"species":true, "features": true, "people" : true, "coastal" : true},
  7:{"species":true, "features": true, "people" : true, "coastal" : true},
  8:{"species":true, "features": true, "people" : true, "coastal" : true},
  9:{"species":true, "features": true, "people" : true, "coastal" : true},
  10:{"species":true, "features": true, "people" : true, "coastal" : true}
});
const ecos = {
    '1': "Gulf of Maine",
    '2': "Virginian",
    "3": "Carolinian",
    "4": "Coastal"
}

export function useMapItems() {
  const router = useRouter();
  const route = useRoute();
  const isResultVersionKey = (value: string) => /^\d+$/.test(value);
  const setLoadingLease = (bool) => loadingLease.value = bool;
  const setBase64QueryString = (b64) => base64QueryString.value = b64;
  const setResultTabLabels = (bool) => showResultTabLabels.value = !showResultTabLabels.value;
  const setAppVersion = (v) => appVersion.value = v;
  const setReleaseDate = (v) => releaseDate.value = v;
  const setMapNotes = (add, text) =>{
    if (add && !mapNotes.value.includes(text)){
      mapNotes.value.push(text)
    }
    else if (!add){
      mapNotes.value = mapNotes.value.filter(item => item !== text);
    }
  };
  const setMapZoom = (z) => mapZoom.value = z;
  const setDrawZoomWarn = (bool) =>drawZoomWarn.value = bool;
  const setFirstPanelClicks = (version, panel, bool) => firstPanelClicks.value[version][panel] = bool;
  const setLoading = (bool) => (loading.value = bool);
  const setQuerying = (bool) => (querying.value = bool);
  const setActiveSpSpotlight = (spCode) => activeSpSpotlight.value = spCode;
  const setActiveHabSpotlight = (habitat) => activeHabSpotlight.value = habitat;
  const setOpacity = (op) => opacity.value = op;
  const setFirstPan = (bool) => firstPan.value = bool;
  const setTileLayers = (obj) => tileLayers.value = obj;
  const setMap = (m) => map.value = m; 
  const setActiveSpGroups = (theme, group) =>{
    activeSpGroups.value[theme] = group;
    processedData.value['activeSpGroups'] = activeSpGroups.value;
  };
  const setActiveCoastalHabitat = (habitat) => {
    activeCoastalHabitat.value = habitat;
    processedData.value['activeCoastalHabitat'] = habitat;
  };
  const setActiveFlagType = (type) =>{
    activeFlagType.value = type;
    processedData.value['activeFlagType'] = type;
  }
  const setActiveFlagValue = (value) =>{
    activeFlagValue.value = value;
    processedData.value['activeFlagValue'] = value;
  }
  const setUserPolygon = (p, version) => {
    userPolygon.value = p;
    userPolygon.value.polyID = version;
    userPolygon.value.version = version;
  }; 
  const getCookieConsentKey = () => {
    const base = import.meta.env.BASE_URL || '/'
    const suffix = base === '/' || base === ''
      ? ''
      : '-' + base.replace(/^\/+|\/+$/g, '').replace(/\//g, '-')
    return `cookie-consent${suffix}`
  }
  const setActiveLayerID = (id) => activeLayerID.value = id;
  const setDrawingActive = (bool) =>drawingActive.value = bool;
  const setDraw = (mapboxDrawObject) => draw.value = mapboxDrawObject;
  const setMapLoaded = (bool) => mapLoaded.value = bool;
  const setActivePane = (pane) => activePane.value = pane;
  const setMapStyleInfo = (layer, attr) =>mapStyleInfo.value = {layer: layer, attr: attr}
  const setDataQuality = (bool) => dataQuality.value = bool;
  const getNextVersionNumber = () =>{
    // const version = Object.keys(cellData.value).length +1;
    let version
    if (Object.keys(cellData.value).length == 0){
      version = 1
    }
    else{
      // find the max value for the key
      const maxV = Math.max(...Object.keys(cellData.value).map(key => parseInt(key)));


      // if there's a missing number (because an AOI was deleted) reuse that version number
      let i =1
      while (i < maxV) {
        if (!Object.hasOwn(cellData.value, i.toString())) {
          version = i;
          break;
        }
        i++;
      }

      // if there's no missing number, its the current max + 1
      if (!version){
        version = maxV + 1
      }
      
    }
    // console.log(version)
    firstPanelClicks.value[version] = {"species":true, "features": true, "people" : true, "coastal" : true}
    return version
  }

  const setSiteNames = (version, name) =>{
    if (name == "DELETE"){
      siteNames.value[version] = `Area ${version}`
    }
    else{
      siteNames.value[version] = name
    }
    
    // console.log(siteNames.value)
  };

  const setLegend =(title, stops, stopNames=null) =>{
    // console.log(stops)
    legendObj.value.content['title'] = title;
    if (!stopNames){
      legendObj.value.content['stops'] = stops;
    }
    else{
      const namedStops = []
      // this stops are set up like [[50, '#FF0000], [75, '#000000]]
      // array.findLast loops through an array in reverse.  Using here because colorStops JSOn
      // lists no data first, but in legend I want Very High first.  And don't want to edit JSON
      stops.findLast((classColorArr) =>{
        namedStops.push([stopNames[classColorArr[0]], classColorArr[1]])
      })
      legendObj.value.content['stops'] = namedStops;
    }

    // console.log(legendObj.value)

  }

  const setCellData = (id, layer, vals, version, area, numCells, ecoregions, majEcoregion) =>{
    // if the AOI is being deleted, need to remove from here
    if (id =="DELETE"){
      delete cellData.value[version]
    }
    else{
      // check if existing result for this poly & append to that poly if so
      let newPoly = true
      let dataObj
      if (Object.keys(cellData.value).length>0){
        dataObj = cellData.value;
      }
      else if (Object.keys(processedData.value).length>0){
        dataObj = JSON.parse(JSON.stringify(processedData.value)); // DEEP COPY!!!
      }
      else{
        dataObj = {}
      }

      // console.log(dataObj)
      // console.log(processedData.value)
      for (const [num, res] of Object.entries(dataObj)) {
        // console.log(id)
        // console.log(res['polyID'])
        if (res['polyID'] == id){
          res[layer] = vals
          newPoly = false
        }
      }

      if (newPoly){
        // console.log("new poly!")
        // Clone the object
        const polyClean = Object.assign({}, userPolygon.value);
        // Remove the taget property which includes map functions
        delete polyClean.target; 
        
        // create empty object in cell Data & processed results for this new site
        if (!processedData.value[version] || processedData.value[version] == undefined){
          processedData.value[version] = {};
          processedData.value[version]['poly'] = polyClean;
          processedData.value[version]['polyID'] = id;
          processedData.value[version]['areaKM2'] = area;
          processedData.value[version]['numCells'] = numCells;
          if (ecoregions){
            processedData.value[version]['ecoregions'] = ecoregions;
            processedData.value[version]['majEcoregion'] = majEcoregion;
          }          
          processedData.value[version]['polyID'] = id;
          processedData.value[version]['name'] = "Area " + version;
          processedData.value[version]['type'] = "processed"
        }

        cellData.value[version] = {};
        cellData.value[version]['poly'] = polyClean;
        cellData.value[version]['polyID'] = id;
        cellData.value[version]['areaKM2'] = area;
        cellData.value[version]['numCells'] = numCells;
        if (ecoregions){
          cellData.value[version]['ecoregions'] = ecoregions;
          cellData.value[version]['majEcoregion'] = majEcoregion;
        }

        cellData.value[version]['name'] = "Area " + version;
        cellData.value[version]['type'] = "raw"
        
        // console.log(cellData);
      }

      if (!cellData.value[version]){cellData.value[version] = {};}

      // console.log(vals)
      cellData.value[version][layer] = vals;
    }
  } 
  

  const addSaveProcessedData = (processedObj) =>{
    // used if loading a saved AOI when there's already an existing processedData object
    // e.g. when loading a lease
    for (const [v, obj] of Object.entries(processedObj)) {
      // in addition to the version #, mapStyle & spSpotlight are passed as the first item in the processed , so need to confirm that the version is actually the version number
      if (isResultVersionKey(v)){
        const version = getNextVersionNumber();
        // console.log(version)
        const polyResult = obj;
        obj['polyID'] = `userPoly${version}`
        obj['poly']['polyID'] = version;
        obj['poly']['version'] = version;
        setQuerying(false);
        setSiteNames(version, polyResult['name'])
        const userPoly = makeCleanJson(polyResult['poly'], version)
        setLoadedResults(version, obj)
        setUserPolygon(userPoly, version)
        zoomToPolygon(userPoly)
        // console.log(processedData.value)
        map.value.once('idle', function(){
          setActivePane('summary')
          router.push(`/results${version}/summary`)
        })
      }
    }
  }

  const loadSavedProcessedData =  (processedObj) =>{
    // this is only used when an entire processedData object is loaded from base64 URL -- as in Share link
    // console.log(processedObj)
    setQuerying(true); // spinner on map
    processedData.value = processedObj;
    let firstPoly
    const routeVersion = route.fullPath.includes("results")
      ? route.fullPath.split("/")[1].replace("results", "")
      : null;
    let firstVersionInSave: string | null = null;
    for (const [version, obj] of Object.entries(processedObj)) {
      // in addition to the version #, mapStyle & spSpotlight are passed as the first item in the processed , so need to confirm that the version is actually the version number
      if (isResultVersionKey(version)){
        if (!firstVersionInSave) {
          firstVersionInSave = version;
        }
        const polyResult = obj;
        setQuerying(false);
        setSiteNames(version, polyResult['name'])
        const userPoly = makeCleanJson(polyResult['poly'], version)
        // just added this
        setLoadedResults(version, obj)
        setUserPolygon(userPoly, version)

        if(version==(routeVersion || firstVersionInSave)){firstPoly = userPoly}
        zoomToPolygon(firstPoly)
      }
     
    }

    const nextVersion = routeVersion || firstVersionInSave || "1";
    watch(mapLoaded, (nv, ov) =>{
      if (nv){
        map.value.once('idle', function(){
          setActivePane('summary')
          router.push(`/results${nextVersion}/summary`)
        })
      }

    })
    

  }

  
  const makeCleanJson = (content, version) =>{
      // console.log(content)
      if (content !=undefined){
        const userPoly = {
            type: "FeatureCollection",
            features:[],
            id: `userPoly_${version}`
        } as any;

        content['features'].forEach((feat)=>{
            userPoly.features.push(feat)
        })
        // console.log(userPoly)
        setUserPolygon(userPoly, version)
        return userPoly
      }
  }

  const setProcessedData = (version, layer, element=null, subelement=null, valObj=null) =>{
    // console.log(version)
    // console.log(layer)
    // console.log(element)
    // console.log(subelement)
    // console.log(valObj)
   
    if (layer == "DELETE"){ // flag to delete the AOI
      delete processedData.value[version]
    }
    else{
      // the spSpotlight is just the active species.. which data to display
      if(version == 'spSpotlight'){
        processedData.value['spSpotlight'] = layer;
      }

      else if(version == 'habSpotlight'){
        processedData.value['habSpotlight'] = layer;
      }

      // the mapStyle is the info to style the map
      else if(version == 'mapStyle'){
        processedData.value['mapStyle'] = layer;
      }

      // everything else is version based AOI resutls
      else{
        // if loading from base64 URL, the whole processedData object gets loaded
        if (!processedData.value[version] && !layer){
            processedData.value[version] = valObj
        }
        else if (!processedData.value[version] && layer){
          processedData.value[version] = {}
        }

        else if (processedData.value[version][layer] === undefined){
          processedData.value[version][layer] = {}
        }

        // usually there's an element, like "dialVals" or "barValues".  But sometime not, like if updating the AOI name
        if (element){
          //sometimes there's a subelement.  Like a specieis group for dial values
          if (subelement && processedData.value[version][layer][element] === undefined){
            processedData.value[version][layer][element] = {}
          }
          if (subelement){
            processedData.value[version][layer][element][subelement] = valObj;
          }

          // but not always
          else if (!subelement){
            processedData.value[version][layer][element] = valObj;
          }
        }
        else{
          processedData.value[version][layer] = valObj;
        }
      }



      // console.log(processedData.value)
      // setBase64QueryString(objToBase64(processedData.value))
    }

    
  }

  const setLoadedResults = (version, obj) =>{
    // console.log(obj)
    // console.log(version)
    
    // during development, tested loaded raw cell values from a json obj
    if (obj.type === 'raw'){
      cellData.value[version] = obj;
      processedData.value[version] = null;  // make an empty object in order to get version counts coorect
    }

    // but it makes more sense to store the processed values
    else if (obj.type === 'processed'){
      processedData.value[version] = obj;
      cellData.value[version] = JSON.parse(JSON.stringify(obj));// DEEP COPY!!!!  // make an empty object in order to get version counts coorect
    }

  }

  const setQueryParams = (items) => {
    for (const [name, value] of Object.entries(items)) {
      if (value != null){
        queryParams.value[name] = value;
      }
      else{
        delete queryParams.value[name];
      }
    }
  };


  // version is passed in in case it's needed to zoom to the polygon before
  // loading data.  If null, then layer is loaded without zooming
  // this is useful for when styling map on fish data for the same
  // polygon, for example
  const toggleLayer = (e=null, layer=null, version=null, query=true) =>{

    clickAttrs.value = []
    // update stats for data layer on layer change
    if (layer){
      // console.log(layer.id)
      // console.log(layer)
      setLoading(true)
      setActiveLayerID(layer.id)
      // console.log(userPolygon.value)


      // if there's a polygon zoom to that layer if the data isn't loaded
      // console.log(version)
      // console.log(processedData.value)
      // console.log(layer)

      if (version && version.value && userPolygon.value && processedData.value[version.value][layer.id] == undefined){

        let drawnPoly
        let features = []
        // console.log(userPolygon)
        if (userPolygon.value.features){
            userPolygon.value.features.forEach(function (feat, i){
              features.push(feat);
            })
          drawnPoly = turf.featureCollection([...features]);
        }
        else{drawnPoly = userPolygon.value.data}
      
        // console.log(drawnPoly)
        const polygonBbox = turf.bbox(drawnPoly);
        // // console.log(polygonBbox)
        const polygonSW = map.value.project([polygonBbox[0], polygonBbox[1]]);
        const polygonNE = map.value.project([polygonBbox[2], polygonBbox[3]]);
        // if the polygon is partially off the map, zoom to it to ensure data is available
        if (polyOffMap.value){
          zoomToPolygon(drawnPoly)
        }
        
      }
      


      // console.log(map.value.getStyle().layers)
      tileLayers.value.forEach((lyr) =>{
        // if a user polygon exists, add the layer below the polygon
        // Actually, no -- just put it underneath the lease layer, which is under shipping lanes, protected areas, etc        
        if (lyr.id == activeLayerID.value && !map.value.getLayer(lyr.id)) { map.value.addLayer(layer, 'ecs-wind-leases') }
        else if (map.value.getLayer(lyr.id) && lyr.id !=activeLayerID.value ) { map.value.removeLayer(lyr.id) }
      })

      if (userPolygon.value){
        // console.log(userPolygon.value)
        // console.log("layer change.  get data when idle")

        // if uploading a shapefile, map will already be idle
        if (map.value.idle){
          if (!layer.id.includes('FISH_TIME')){
            // don't need to get data for individual fish decade layers.  only for map display
            // since table uses combined decade data
            getData(userPolygon.value.polyID)
          }
        }

        // but when sketching, need to wait for it to be idel
        else{
          map.value.once('idle', function(){
            // console.log("map idle")
            if (!layer.displayOnly && query){
              // don't need to get data for individual fish decade layers or QUALITY layers.  only for map display
              // since table uses combined decade data
              getData(userPolygon.value.polyID)
            }

            setLoading(false)
          })
        }

      }
    }

    map.value.on('mousemove', activeLayerID.value, (e) =>{
      if (drawingActive.value){
        map.value.getCanvas().style.cursor = 'crosshair';        
      }
    })

    map.value.on('mouseleave', activeLayerID.value, (e) => {
      if (drawingActive.value){
        map.value.getCanvas().style.cursor = 'default';

      }
    })
  }


  const getData = (version, attempt=1, override=false) =>{
    // only run getData if the data for this layer isn't already available for this polygon
    // override bypasses logic & getsData.  Used if returning from a saved link with a species group selected.  
    // Need to getData so can get other sp groups

    // console.log(cellData.value)
    // console.log(cellData.value[version])
    // console.log(processedData.value[version])
    // console.log(activeLayerID.value)
    if (
      ((
        processedData.value[version][activeLayerID.value] === undefined || 
        processedData.value[version][activeLayerID.value].length ==0
      ) && 
      ( processedData.value[version]['inBounds'] != 'outside' && 
        (
          cellData.value[version] == undefined || 
          cellData.value[version][activeLayerID.value] === undefined 
        )
      )) || override
    ){
      // console.log(`Getting ${activeLayerID.value} data in getdata.  version`, version)

      let drawnPoly
      let features = []
      if (userPolygon.value.features){
          userPolygon.value.features.forEach(function (feat, i){
            features.push(feat);
          })
        drawnPoly = turf.featureCollection([...features]);
      }
      else{drawnPoly = userPolygon.value.data}
      // console.log(drawnPoly)
      const polygonBbox = turf.bbox(drawnPoly);
      const polygonSW = map.value.project([polygonBbox[0], polygonBbox[1]]);
      const polygonNE = map.value.project([polygonBbox[2], polygonBbox[3]]);
      
      // // zoom to polygon in toggleLayers, BEFORE toggleing the layer on
      // zoomToPolygon(drawnPoly)

      const cells = JSON.parse(JSON.stringify(map.value.queryRenderedFeatures([[polygonSW.x, polygonSW.y], [polygonNE.x, polygonNE.y]], {layers: [activeLayerID.value]})));
      // console.log(cells)

      // if no cells are returned, it might be because the map has been
      // panned away from the polygon.  So try getData 1 more time again
      if (cells.length == 0 && attempt<3){
        const a = attempt + 1
        setTimeout(() => {
          getData(version, a)
        }, 2000);
      }

      // Intersect cells using turf.intersect
      const thisCellData = [];
      const ids = []
      const ecoregions = []
      
      for (let i = 0; i < cells.length; i++) {
          // console.log(cells[i]);
          if (drawnPoly.features){
            for (let j = 0; j < drawnPoly.features.length; j++) {
              const polySimp = JSON.parse(JSON.stringify(drawnPoly.features[j]))
              polySimp.type = "Feature";
              polySimp.properties = {};
              try {
                  const cell = cells[i]
                  const intersection = turf.intersect(turf.featureCollection([polySimp, cell]));
                  if (intersection != null) {
                    // sometimes cells get added twice -- overlapping tiles.  So only add if not already in list of IDs
                    if (!ids.includes(cell.properties.GRID_ID)){
                      // console.log(cell.properties);
                      thisCellData.push(cell.properties);
                      ids.push(cell.properties.GRID_ID)

                      // only need to get ecoregions the first time
                      if(activeLayerID.value == 'FLAGS'){
                        ecoregions.push(cell.properties.ECOREG)
                      }
                      
                    }
                  }
              } catch (e) {
                  console.error("intersect error", e);
              }
            }
            
          }
          else{
            try {
                const cell = cells[i]
                const intersection = turf.intersect( turf.featureCollection([cell, drawnPoly]));
                if (intersection) {
                    // sometimes cells get added twice -- overlapping tiles.  So only add if not already in list of IDs
                    if (!ids.includes(cell.properties.GRID_ID)){
                      // console.log(cell.properties);
                      thisCellData.push(cell.properties);
                      ids.push(cell.properties.GRID_ID)
                      
                      // only need to get ecoregions the first time
                      if(activeLayerID.value == 'FLAGS'){
                        ecoregions.push(cell.properties.ECOREG)
                      }
                    }
                }
              } catch (e) {
                  console.error("intersect error", e);
              }
          }
      }
      // console.log(cellData);
      // console.log(ids);
      // console.log(thisCellData)

      const polyID = `userPoly${version}`
      const areaKM2 = turf.area(drawnPoly)/1000000;
      // console.log(areaKM2)
      const numCells = thisCellData.length;


      // only need to get ecoregions the first time
      let ecoreg = null
      let majEco = null
      if (!processedData.value || processedData.value[version] == undefined || processedData.value[version]['majEcoregion'] == undefined){
        ecoreg = Array.from(new Set(ecoregions))
        const numEcoregCells = {}
        const countOccurrences = (arr, val) => arr.reduce((a, v) => (v === val ? a + 1 : a), 0);
        // calculate the majority ecoregion, used for comparisons
        ecoreg.forEach((eco) =>{
          // console.log(eco)
          numEcoregCells[eco] = countOccurrences(ecoregions, eco)
        })

        // console.log(numEcoregCells)
        majEco = Object.keys(numEcoregCells).reduce((a, b) => numEcoregCells[a] > numEcoregCells[b] ? a : b);

      }
      else{
        ecoreg = processedData.value[version]['ecoregions']
        majEco = processedData.value[version]['majEcoregion']
      }

      // console.log(thisCellData)
      // console.log(cellData.value)
      // console.log(version)
      setCellData(polyID, activeLayerID.value, thisCellData, version, areaKM2, numCells, ecoreg, majEco)
      

      // if it's a new result or toggling between exsiting versions, push to the Flags (summary) pane on results
      if (route.path.includes('select')){
        // console.log("router push from getData()")
        setActivePane('summary')
        router.push(`/results${version}/summary`)
      }
  
 
    } 
    else{
      // console.log("data already loaded, not getting")
    }
    
  }

  const testInBounds = () => {
    let drawnPoly;
    let features = [];

    if (userPolygon.value.features) {
        userPolygon.value.features.forEach(function (feat) {
            features.push(feat);
        });
        drawnPoly = turf.featureCollection([...features]);
    } else {
        drawnPoly = userPolygon.value.data;
    }

    const polygonBbox = turf.bbox(drawnPoly);
    const polygonSW = map.value.project([polygonBbox[0], polygonBbox[1]]);
    const polygonNE = map.value.project([polygonBbox[2], polygonBbox[3]]);

    // used to test if completely outside study area
    const grid = map.value.queryRenderedFeatures([[polygonSW.x, polygonSW.y], [polygonNE.x, polygonNE.y]], { layers: [activeLayerID.value] });

    if (drawnPoly.features) {
        if (grid.length === 0) {
            return 'outside';
        } else {
            let isStraddle = false;
            boundary.value.features.forEach(boundaryFeature => {
                drawnPoly.features.forEach(drawnFeature => {
                    // Check if the feature is a MultiPolygon
                    if (drawnFeature.geometry.type === 'MultiPolygon') {
                        drawnFeature.geometry.coordinates.forEach(polygon => {
                            const multiPolygonFeature = feature({
                                type: "Polygon",
                                coordinates: polygon
                            });
                            const crosses = turf.booleanCrosses(boundaryFeature, multiPolygonFeature);
                            if (crosses) {
                                isStraddle = true;
                            }
                        });
                    } else {
                        const crosses = turf.booleanCrosses(boundaryFeature, drawnFeature);
                        if (crosses) {
                            isStraddle = true;
                        }
                    }
                });
            });
            if (isStraddle) {
                // console.log('straddle!');
                return 'straddle';
            } else {
                return 'inside';
            }
        }
    }
};


  const logGAevent = (name, category, label) => {
    const consent = LocalStorage.getItem(getCookieConsentKey())
    if (consent === 'accepted' && window.gtag) {
      event(name, {
        event_category: category,
        event_label: label,
      });
    }
  };

  const printing = ref(false)

  const getShareURL= () =>{
    setBase64QueryString(objToBase64(processedData.value))
    const b64URL = window.location.origin + import.meta.env.BASE_URL + "#" + route.fullPath + "?b64="+ base64QueryString.value
    logGAevent('share_url', "", "")
    return b64URL
  }

  const filterNode = (node) =>{
    if (node.class != 'print-hide'){return node}
  }

  const print = async (divName, version, theme) =>{
    try{
    const opts = {preserveDrawingBuffer : true}
    
    printing.value = true;

    const stamp =  new Date().toLocaleString().replaceAll("/", "-").replaceAll(", ", "_").replaceAll(":", "-");
    logGAevent('print_result', 'print', stamp)
    
    // use 'print-hide' class to exclude any elements from screenshot!
    let div_image = await domToPng(document.querySelector(`#${divName}`), {
      scale: 10, 
      filter: (node) => {
        return !(node instanceof Element && node.classList.contains('print-hide'))
      }
    })

    // let div_image = await captureDivImage(`${divName}`, 500)



    
    const map_image = await domToPng(document.querySelector('#mapContainer'), {scale: 3})

    // console.log(map_image)

    let docDefinition = {
      content: [

        { text: `Marine Mapping Tool Analysis ${theme}: ${siteNames.value[version]}`, style: 'header'},
        { text: 'Visit this site on the tool', link:  getShareURL(), style:'link'},
       
        {
          image: div_image,
          width: 400,
          margin: [10, 10, 10, 10]
        },
        {
          image: map_image,
          width: 400,
          margin: [10, 10, 10, 10]
        }
      
  
      ],
      styles: {
        banner: {
          fontSize: 18,
          bold: true,
          background: '#24302b',
          color: "white"
        },
        header: {
          fontSize: 18,
          bold: true,
          margin: [0, 20, 0, 0]
        },
        map: {
          border: true
        },
        link: {
          color: 'blue',
          decoration:'underline',
          margin: [0, 0, 0, 20]
        },
        warning: {
          fontSize: 14,
          color: 'red'
        },
        image: {
          display: 'block',
          marginLeft: 'auto',
          marginRight: 'auto',
          width: '50%',
        }
      }
    };
    const pdf = pdfMake.createPdf(docDefinition)
    printing.value = false;
    pdf.download(`MMT_Result_${stamp}.pdf`)
    return pdf
    }
    catch(e){
      console.log(e)
    }

  };

  const captureDivImage = async (divId, pageHeight) => {
    const myDiv = document.getElementById(divId);
  
    if (!myDiv) {
      throw new Error(`Element with id ${divId} not found`);
    }
  
    // Ensure all nested scroll areas are fully expanded
    const expandScrollAreas = (element) => {
      const scrollableElements = element.querySelectorAll('*');
      scrollableElements.forEach((el) => {
        if (el.scrollHeight > el.clientHeight || el.scrollWidth > el.clientWidth) {
          el.style.height = `${el.scrollHeight}px`;
          el.style.width = `${el.scrollWidth}px`;
        }
      });
    };
  
    expandScrollAreas(myDiv);
  
    const dataUrl = await domToPng(myDiv, {
      onCloneNode: (clonedDoc) => {
        const clonedDocument = clonedDoc as Document;
        const clonedElement = clonedDocument.querySelector(`#${divId}`) as HTMLElement;
        if (clonedElement) {
          clonedElement.style.display = 'block';
          expandScrollAreas(clonedElement);
        }
      },
      width: myDiv.scrollWidth,
      height: myDiv.scrollHeight,
    });
  
    const img = new Image();
    img.src = dataUrl;
  
    await new Promise((resolve) => {
      img.onload = resolve;
    });
  
    const canvas = document.createElement('canvas');
    const ctx = canvas.getContext('2d');
    const parts = [];
    let currentY = 0;
  
    while (currentY < img.height) {
      canvas.width = img.width;
      canvas.height = Math.min(pageHeight, img.height - currentY);
      ctx.drawImage(img, 0, currentY, img.width, canvas.height, 0, 0, img.width, canvas.height);
      parts.push(canvas.toDataURL());
      currentY += pageHeight;
    }
  
    return parts;
  };

  // const captureDivImage = async (divId, pageHeight) => {
  //   const myDiv = document.getElementById(divId);
  
  //   if (!myDiv) {
  //     throw new Error(`Element with id ${divId} not found`);
  //   }
  
  //   const dataUrl = await domToPng(myDiv, {
  //     onCloneNode: (clonedDoc) => {
  //       const clonedDocument = clonedDoc as Document;
  //       const clonedElement = clonedDocument.querySelector(`#${divId}`) as HTMLElement;
  //       if (clonedElement) {
  //         clonedElement.style.display = 'block';
  //       }
  //     }
  //   });
  
  //   const img = new Image();
  //   img.src = dataUrl;
  
  //   await new Promise((resolve) => {
  //     img.onload = resolve;
  //   });
  
  //   const canvas = document.createElement('canvas');
  //   const ctx = canvas.getContext('2d');
  //   const parts = [];
  //   let currentY = 0;
  
  //   while (currentY < img.height) {
  //     canvas.width = img.width;
  //     canvas.height = Math.min(pageHeight, img.height - currentY);
  //     ctx.drawImage(img, 0, currentY, img.width, canvas.height, 0, 0, img.width, canvas.height);
  //     parts.push(canvas.toDataURL());
  //     currentY += pageHeight;
  //   }
  
  //   return parts;
  // };


// //  !!!!!!!  use this to try getting the hidden portions of divs in print output, otherwise, eg, mammal bar charts that extent beyond a page div stay visible.  
// const captureDivImage = async (divId, pageHeight) => {

//   // Call as in:
//   // const pageHeight = 792; // Example page height in pixels (A4 size at 72 DPI)
//   // const images = ref([]);
//   // images.value = await captureDivImage('myDiv', pageHeight);


//   const myDiv = document.getElementById(divId);

//   if (!myDiv) {
//     throw new Error(`Element with id ${divId} not found`);
//   }

//   const dataUrl = await domToPng(myDiv, {
//     onCloneNode: (clonedDoc) => {
//       const clonedDocument = clonedDoc as Document;
//       clonedDocument.getElementById(divId).style.display = 'block';
//     }
//   });



// // might want to test this -- increae the DPI resolution
// // const convertPixelsToPoints = (pixels, dpi = 96) => (pixels / dpi) * 72;
// // const imageWidthInPixels = 800; // Example width in pixels
// // const imageHeightInPixels = 600; // Example height in pixels
// // const imageWidthInPoints = convertPixelsToPoints(imageWidthInPixels, 300); // Convert using 300 DPI
// // const imageHeightInPoints = convertPixelsToPoints(imageHeightInPixels, 300); // Convert using 300 DPI
// // const docDefinition = {
// //   content: [
// //     {
// //       image: 'data:image/png;base64,...', // Your image data URL
// //       width: imageWidthInPoints,
// //       height: imageHeightInPoints
// //     }
// //   ]
// // };
// // // Create the PDF
// // pdfMake.createPdf(docDefinition).download('document.pdf');





//   const img = new Image();
//   img.src = dataUrl;

//   await new Promise((resolve) => {
//     img.onload = resolve;
//   });

//   const canvas = document.createElement('canvas');
//   const ctx = canvas.getContext('2d');
//   const parts = [];
//   let currentY = 0;

//   while (currentY < img.height) {
//     canvas.width = img.width;
//     canvas.height = Math.min(pageHeight, img.height - currentY);
//     ctx.drawImage(img, 0, currentY, img.width, canvas.height, 0, 0, img.width, canvas.height);
//     parts.push(canvas.toDataURL());
//     currentY += pageHeight;
//   }

//   return parts;
// };





  const zoomToPolygon = (poly) =>{
    // zoom to polygon
    try{
      const polygonBbox = turf.bbox(poly);    
      const bounds1 = [polygonBbox[0], polygonBbox[1]]
      const bounds2 = [polygonBbox[2], polygonBbox[3]]
      const bounds = [bounds1, bounds2]
      if(mapLoaded.value){
        map.value.fitBounds(bounds, { padding: 100 })
      }
      else{// if loading saved data from base64, map does not yet exist
        watch(mapLoaded, (nv, ov) =>{
          if (nv){map.value.fitBounds(bounds, { padding: 100 })}
        })
      }

      
    }
    catch(err){console.log(err)}

    
  };
  const popup = ref(null)
  const styleMap = (layerID, attr, type, stops, valueNames=null) =>{
    // console.log(layerID, attr, type, stops)
    if (popup.value){popup.value.remove()};
    logGAevent('style_map', layerID, attr)
    const styleObj = {
      layerID:layerID,
      attr:attr,
      type:type,
      stops:stops,
      valueNames:valueNames
    }
    setProcessedData('mapStyle', styleObj)

    setMapStyleInfo(layerID, attr)

    let fillObj
    if (type == 'categorical'){
      fillObj = {
        property: attr,
        stops: stops,
        type: type
      }
    }
    else if (type == 'interpolate'){
      const flatStops = stops.flat();
      fillObj = [
        "interpolate",
        ["linear"],
        ["get", attr],
        ...flatStops
      ]
    }
    else if (type == 'step'){
      const flatStops = stops.flat();
      fillObj = [
        "step",
        ["get", attr],
        'rgba(0,0,0,0)',
        ...flatStops
      ]
    }
    else if (type == 'match'){
      const flatStops = stops.flat();
      fillObj = [
        "match",
        ["get", attr],
        stops[0][0], stops[0][1],
        stops[1][1]
      ]
    }
    else if (type == 'expression'){
      // stops IS the full MapLibre expression array (e.g. ['case', ...])
      fillObj = stops
    }

    // console.log(fillObj)
    // console.log(layerID)
    // set up so that styled layers can be click-queried.  So highlight the active cell with an outline
    // this isn't working... after highlight, always reverts to the default color.  
    // const fillOutline = [
    //   'case',
    //   ['boolean', ['feature-state', 'highlight'], false],
    //   "#000000", // outline when highlighted
    //   ['match', ['get', attr], ...stops.flat(), '#FF0000'] // Use stops for other cases
    // ];

    // cast to any because MapLibre typings expect a string but we pass expressions/arrays
    map.value.setPaintProperty(layerID, 'fill-color', fillObj as any);
    map.value.setPaintProperty(layerID, 'fill-outline-color', fillObj as any);
    map.value.setPaintProperty(layerID, 'fill-opacity', opacity.value/100);

    
    enableMapQueryClick(layerID, attr, valueNames)
  };

  const popupEnabled = ref(false);
  
  const enableMapQueryClick = (layerID, attr, valueNames) =>{
    // This creates the popup in the map and highlights the active cell
    let clickID = null;


    map.value.on('click', layerID, (e) => {
      if (!popupEnabled.value) {
        // console.log(mapStyleInfo.value)
        // only query the map if the attr being passed in is the one that is styled in the map
        // before this, multiple popups would show if multiple layers had been toggled on/off
        if (mapStyleInfo.value['attr'] === attr){
          mapQuery(e, attr, valueNames, clickID)
        }
      }
    });
  }

  const mapQuery = (e,  attr, valueNames, clickID) =>{
    if (!drawingActive.value){
      clickAttrs.value = []
      let popupText = ""
      // console.log(e)
      // console.log(activeLayerID.value)
      for (const [key, value] of Object.entries(e.features[0].properties)) {
        if (key == 'GRID_ID'){popupText += `<div><strong>${key}</strong>: ${value} </div>`}
        if (key == 'ECOREG'){
          const typedValue = value as keyof typeof ecos; 
          popupText += `<div><strong>Ecoregion</strong>: ${ecos[typedValue]} </div>`
        }
        if (key == attr){
          let k
          let v
          
          // if it's a species layer, see if there's a Sp nameto use (e.g. "Atlantic Mackerel" instead of "SP100")
          const species_keywords = ['FISH', 'MAMMAL', 'BIRD', 'TURTLE', 'CORAL']
          if (containsSubstring(activeLayerID.value, species_keywords) && AllCodes[key]){ k = AllCodes[key]}
          else{k = key}

          // see if there's a value name to use (e.g. "Very High" instead of 90)
          if (valueNames){
            const typedValue2 = value as keyof typeof valueNames; 
            if (valueNames[typedValue2] != undefined){
              v = valueNames[typedValue2]
            }
          }
          else{v = value}

          if (v == undefined){
            v = value;
          }
          
          clickAttrs.value.push({'attr' : key, 'value': value});
          popupText += `<div><strong>${k}</strong>: ${v} </div>`

 
          popup.value = new M.Popup();
          popupEnabled.value = true;

          popup.value.on('open', () => {
            // console.log('popup was opened');
          });
          popup.value.setLngLat(e.lngLat).setHTML(popupText).addTo(map.value);
            
          // Listen for the popup close event to reset the state
          popup.value.on('close', () => {
            popupEnabled.value = false;
          });

        }
      }



      const layer = e.features[0].layer
      // console.log("querying " + layerID)
      // apply the feature-state higlighted class so taht the cell gets highlighted
      if (e.features.length > 0) {
        const feature = e.features[0];
        if (feature && feature.id !== undefined){
          if (clickID !== null && clickID !== feature.id) {
            map.value.setFeatureState(
              { source: layer.source, sourceLayer: layer['source-layer'], id: clickID },
              { highlight: false }
            );
          }
          clickID = feature.id;
          // console.log(clickID)
          map.value.setFeatureState(
            { source: layer.source, sourceLayer: layer['source-layer'], id: clickID },
            { highlight: false }
          );
        }else {
          console.warn('Feature or feature ID is null or undefined');
        }
      }
    }
  }

  const clearMapStyle = (lyrID=null) =>{
    const mapObj = map.value;
    if (!mapObj) return;

    const layerID = lyrID ?? activeLayerID.value;
    if (!layerID || !mapObj.getLayer?.(layerID)) return;

    // Reset fill style so the layer doesn't draw when the data is cleared
    mapObj.setPaintProperty(layerID, 'fill-color', '#88888800');
    const fillOutline =  [ 
        'case',
        ['boolean', ['feature-state', 'highlight'], false],
        "#d90bc8",
        "#888888",
    ]
    mapObj.setPaintProperty(layerID, 'fill-outline-color', fillOutline);
    const fillOpacity = [
      'case',
      ['boolean', ['feature-state', 'highlight'], false],
      1,
      0.1,
    ]
    mapObj.setPaintProperty(layerID, 'fill-opacity', fillOpacity);
    
    // clear the mapStyleInfo object so that legend and highglihted stacked bar rows are cleared
    for (var key in mapStyleInfo.value) {
        delete mapStyleInfo.value[key];
    }
    legendObj.value.content = {}
    

    //clear the ports and highlighted port if coming from People tab
    const portFilter =  ["==", 'TOWNCODE', 'xx'];

    if (mapObj.getLayer('crcs-ne-cas-ports')) {
      mapObj.setLayoutProperty('crcs-ne-cas-ports', 'visibility', 'none');
      mapObj.setFilter('crcs-ne-cas-ports', portFilter);
    }

    if(mapObj.getLayer('highlighted-port')) {
        mapObj.setLayoutProperty('highlighted-port', 'visibility', 'none');
        mapObj.setFilter('highlighted-port', portFilter);
    }

    // remove the map style from saved object so doesn't load back from that
    delete processedData.value['mapStyle']
  }  

  const showRestorationProjectPoint = (lat: number, lng: number, zoom: number = 10, durationMs: number | null = null) => {
    if (!map.value) return;
    if (!Number.isFinite(lat) || !Number.isFinite(lng)) return;

    if (restorationProjectMarker) {
      restorationProjectMarker.remove();
      restorationProjectMarker = null;
    }

    const el = document.createElement('div');
    el.style.width = '18px';
    el.style.height = '18px';
    el.style.borderRadius = '50%';
    el.style.backgroundColor = '#1D8177';
    el.style.border = '2px solid black';
    el.style.boxShadow = '0 0 6px rgba(0,0,0,0.35)';
    el.style.pointerEvents = 'none';

    restorationProjectMarker = new M.Marker({ element: el })
      .setLngLat([lng, lat])
      .addTo(map.value);

    map.value.flyTo({
      center: [lng, lat],
      zoom,
      duration: 1000
    });
  };

  const clearRestorationProjectPoint = () => {
    if (restorationProjectMarker) {
      restorationProjectMarker.remove();
      restorationProjectMarker = null;
    }
  };

  const clearRestorationProjectHighlightPoints = () => {
    if (restorationProjectHighlightMarkers.length) {
      restorationProjectHighlightMarkers.forEach((m) => m.remove());
      restorationProjectHighlightMarkers.length = 0;
    }
  };

  const showRestorationProjectHighlightPoints = (points: Array<{ lat: number; lng: number }>) => {
    if (!map.value) return;
    clearRestorationProjectHighlightPoints();

    for (const point of points) {
      const { lat, lng } = point;
      if (!Number.isFinite(lat) || !Number.isFinite(lng)) continue;

      const el = document.createElement('div');
      el.style.width = '14px';
      el.style.height = '14px';
      el.style.borderRadius = '50%';
      el.style.backgroundColor = '#1D8177';
      el.style.border = '2px solid white';
      el.style.boxShadow = '0 0 6px rgba(0,0,0,0.35)';
      el.style.pointerEvents = 'none';

      const marker = new M.Marker({ element: el })
        .setLngLat([lng, lat])
        .addTo(map.value);

      restorationProjectHighlightMarkers.push(marker);
    }
  };


  const setPolyOffMap = (map, polygon) => {
    
    const bounds = map.getBounds();
    const boundsPolygon = turf.bboxPolygon([bounds.getWest(), bounds.getSouth(), bounds.getEast(), bounds.getNorth()]);
    let isOffMap = false;
    polygon.features.forEach(polyFeature => {
        if (polyFeature.geometry.type === 'MultiPolygon') {
            polyFeature.geometry.coordinates.forEach(coords => {
                const multiPolygonFeature = feature({
                    type: "Polygon",
                    coordinates: coords
                });
                if (!turf.booleanContains(boundsPolygon, multiPolygonFeature)) {
                    isOffMap = true;
                    logGAevent('poly_off_map', "", "")
                }
            });
        } else {
            if (!turf.booleanContains(boundsPolygon, polyFeature)) {
                isOffMap = true;
                logGAevent('poly_off_map', "", "")
            }
        }
    });
    // console.log(isOffMap);
    polyOffMap.value = isOffMap;
};


  const arrayFindObjectByProp = (arr, prop, val) => {
    return arr.find((obj) => obj[prop] == val);
  };

  const loadDataByID = (layerID, version) =>{
    logGAevent("load_data",   layerID, "")
    if (map.value){
      if (layerID != activeLayerID.value){ // in some cases, the layer may already be loaded
        // if the ref is passed in
        let v
        if (typeof version === 'object' && version !== null){
          v = version
        }
        else{ // otherwise if the number is passed in, but toggle layer expects a ref
          v = ref(version)
        }

        const layer = arrayFindObjectByProp(tileLayers.value, 'id', layerID)

        toggleLayer(true, layer, v)
      }
    }

    else {
      watch(mapLoaded, (nv, ov) =>{
        if (nv){
          if (layerID != activeLayerID.value){ // in some cases, the layer may already be loaded
          // if the ref is passed in
          let v
          if (typeof version === 'object' && version !== null){
            v = version
          }
          else{ // otherwise if the number is passed in, but toggle layer expects a ref
            v = ref(version)
          }

          const layer = arrayFindObjectByProp(tileLayers.value, 'id', layerID)
          toggleLayer(true, layer, v)
        }
        }
      }, { once: true })
    }
  }


   const objToBase64 = (obj) =>{
    try{
      const jsonString = JSON.stringify(obj);
      const compressed = pako.deflate(jsonString);
      const base64String = btoa(String.fromCharCode.apply(null, new Uint8Array(compressed)));
      return toUrlSafeBase64(base64String);
    }
    catch (error) {
        console.error('Compression error:', error);
        return null;
    }
  }
  const toUrlSafeBase64 = (base64String) => {
      return base64String.replace(/\+/g, '-').replace(/\//g, '_').replace(/=+$/, '');
  }

  const containsSubstring = (substring, list) =>{
    return list.some(str => str.includes(substring));
  }


  // functions that get reused for mutliple species groups (mammals, birds, turtles, corals)
  const processDialData = (version, data, spLayer, activeSpGroup, majEcoregion, season, SpGroups, MeanSDs, presVal, gtVal) =>{
    // console.log(processedData.value[version.value])
    // console.log(processedData.value[version.value][fishLayer.value])
    // console.log(processedData.value[version.value][fishLayer.value]['summaryDial'])
    if ( // if the data doesn't exist in the processedData object, then calculate it
        !processedData.value[version.value] || 
        processedData.value[version.value][spLayer.value] === undefined || 
        processedData.value[version.value][spLayer.value]['summaryDial']===undefined || 
        processedData.value[version.value][spLayer.value]['summaryDial'][activeSpGroup.value.value]===undefined
      ){
        const cellData = data.value[spLayer.value];

        if (cellData){
          // console.log("calculating new dial results")

          const grp = activeSpGroup.value.value;
          // console.log(grp)
          // console.log(majEcoregion)
          // console.log(season)
          let mean
          let sd
          if (MeanSDs[grp]){
            mean = MeanSDs[grp]['MEAN'][majEcoregion.toString()][season.value.value]
            sd = MeanSDs[grp]['SD'][majEcoregion.toString()][season.value.value]
          }
          
          let sppPres = []
          let gtValPres = []
          cellData.forEach((cell) =>{
              SpGroups[grp].forEach((sp) =>{
                  // console.log(cell[sp])
                  if (cell[sp] >=presVal){sppPres.push(sp)}
                  if (cell[sp] >=gtVal){gtValPres.push(sp)}
              })
          })
  
          // console.log(sppPres)
          // console.log(Array.from(new Set(sppPres)))
          const numSpp = Array.from(new Set(sppPres)).length
          const numGTVal = Array.from(new Set(gtValPres)).length

          const getZscore =(val, mean, sd) =>{
            return (val - mean) / sd;
          }
  
          let dialVal = getZscore(numGTVal, mean, sd)
          if (dialVal >2.5){dialVal = 2.5}
          if (dialVal <-2.5){dialVal = -2.5}
  
          const resObj = {dialVal: dialVal, numSpp: numSpp, numGTVal: numGTVal}
          // console.log(resObj)
          // console.log(version.value)
          // console.log(fishLayer.value)
          setProcessedData(version.value, spLayer.value, 'summaryDial', grp, resObj)
          return {dialVal: dialVal, numSpp: numSpp, numGTVal: numGTVal}
        }
        else{
          return null
        }
        
    }
    else{
      // if the data does exist in the processedData object, then load it
      // console.log("loading saved processed dial results")
      const dialInputs = processedData.value[version.value][spLayer.value]['summaryDial'][activeSpGroup.value.value]
      return {dialVal: dialInputs['dialVal'], numSpp: dialInputs['numSpp'], numGTVal: dialInputs['numGTVal']}
    }
  }

  const processStackedBarData = (version, data, spLayer, activeSpGroup, SpGroups, AllCodes, barCategories, barSortOrder, percHVHVals=[], sightingSuffix=null) =>{
    // console.log(processedData.value[version.value][spLayer.value])
    // console.log(activeSpGroup)
    if (
      !processedData.value[version.value] || 
      processedData.value[version.value][spLayer.value] === undefined || 
      processedData.value[version.value][spLayer.value]['barData']===undefined || 
      processedData.value[version.value][spLayer.value]['barData'][activeSpGroup.value.value]===undefined
    ){
      // console.log("Processing new bar data")
      const workingData = []
      const sightings = {}

      if (sightingSuffix){
        SpGroups[activeSpGroup.value.value].forEach((sp) => {
          sightings[sp] = 0
        });
      }

      // console.log(data.value)
      const cellData = data.value[spLayer.value];
      // console.log(cellData)
      let isCellData = true
      if (cellData == undefined || cellData[0] == undefined){
        isCellData = false;
        return 'need data'
      }
      if (cellData && isCellData) { // confirm that it is actually array of cell data, not processed data
          // console.log(cellData)

          // create arrays to hold the results for each species
          const spData = {}
          SpGroups[activeSpGroup.value.value].forEach((sp) => {
              spData[sp] = []
          });

          // loop through the cell data and push the values into an array for each species
          cellData.forEach((cell) =>{
              Object.keys(spData).forEach((sp) => {
                  spData[sp].push(cell[sp]);
                  if (sightingSuffix){
                    const sightField = sp + sightingSuffix
                    if (cell[sightField] == 1){
                      sightings[sp] = 1
                    }
                  }
              });
          })
          
          // count the occurences of each category for each species and put into an object for that species
          // thne push into the workingData array
          for (const [spID, values] of Object.entries(spData)) {

              // get the # of cells -- used to calc % 
              const numCells = (spData[spID].length);

              // initialize the % high / very high
              let percHVH = 0

              // loop through the bar categories obert and populate the working data
              // bar categories like {"-9" : "No Data", "0" : "Absent",  "1" : "Present"} 
              for (const [strVal, name] of Object.entries(barCategories)) {
                
                // convert string (passed in object because some are negative)
                const val = parseInt(strVal) 

                const countOccurrences = (arr, val) => arr.reduce((a, v) => (v === val ? a + 1 : a), 0);

                // calculate the % of the AOI in that category
                const perc = Math.round((countOccurrences(values, val) / numCells *100) *10 /10);

                // if the value is in the array of high / very high values to include, then add to percHVH 
                // this is to have the text "58% High"
                if (percHVHVals.includes(val)){percHVH += perc}
                const obj = {
                    "spID" : spID, // not used in bars, but can pull iot out for sp row
                    "percHighVH" : percHVH, // not used in bars, but can pull iot out for sp row
                    "sp" : AllCodes[spID],
                    "category" : name,
                    "value" : perc
                }
                if (sightingSuffix){
                  obj["sighting"] = sightings[spID]
                }
                workingData.push(obj)
              }
          }
      }
      else{
        return null
      }
      // console.log(workingData)
      const sortedBarData = groupSortIndividBarArrays(workingData, barSortOrder, 'sp')
      // console.log(sortedBarData)
      // return finalBarData if all data are passed into a single StackBarChart component
      // return sortedBarData if looping through and creating a separate StackedBarChart componet for each row
      // this is done so that other elemnts: like an sightings check mark or other values can be added to the row
      // console.log(activeSpGroup)
      setProcessedData(version.value, spLayer.value, 'barData', activeSpGroup.value.value, sortedBarData)
      return sortedBarData

    }
    else{
      // console.log("loading saved processed bar chart results")
      const barData = processedData.value[version.value][spLayer.value]['barData'][activeSpGroup.value.value]
      return barData
    }
  }
  const groupSortIndividBarArrays = (data, categories, groupByProp) => {
    // this takes an array of objects like the following and returns an array of arrays, one array for each sp.
    // THey are sorted based on the categories passed in, so that the sp with the most "Very High" come first.
    // Within each sp, the Very High object, also comes first
    // const data [
    //   { "sp": "Black Sea Bass", "category": "Absent", "value": 0 },
    //   { "sp": "Black Sea Bass", "category": "No Data", "value": 0 },
    //   { "sp": "Black Sea Bass", "category": "Present", "value": 0 },
    //   { "sp": "Black Sea Bass", "category": "Median", "value": 0 },
    //   { "sp": "Black Sea Bass", "category": "High", "value": 0 },
    //   { "sp": "Black Sea Bass", "category": "Very High", "value": 100 },
    //   { "sp": "Northern Searobin", "category": "Absent", "value": 0 },
    //   { "sp": "Northern Searobin", "category": "No Data", "value": 0 },
    //   { "sp": "Northern Searobin", "category": "Present", "value": 0 },
    //   { "sp": "Northern Searobin", "category": "Median", "value": 0 },
    //   { "sp": "Northern Searobin", "category": "High", "value": 0 },
    //   { "sp": "Northern Searobin", "category": "Very High", "value": 100 }
    // ];

    // Group the data by the specified property
    const groupedData = data.reduce((acc, item) => {
      if (!acc[item[groupByProp]]) {
        acc[item[groupByProp]] = [];
      }
      acc[item[groupByProp]].push(item);
      return acc;
    }, {});

    // Sort each group based on the categories array
    for (let group in groupedData) {
      groupedData[group].sort((a, b) => {
        for (let category of categories) {
          if (b.category === category && a.category !== category) {
            return 1;
          } else if (a.category === category && b.category !== category) {
            return -1;
          }
        }
        return 0;
      });
    }

    // Sort the groups based on the highest value in the specified categories
    const sortedGroups = Object.keys(groupedData).sort((a, b) => {
      for (let category of categories) {
        const aValue = groupedData[a].find(d => d.category === category)?.value || 0;
        const bValue = groupedData[b].find(d => d.category === category)?.value || 0;
        if (bValue !== aValue) {
          return bValue - aValue;
        }
      }
      return 0;
    });

    // Return the sorted groups as an array of arrays
    return sortedGroups.map(group => groupedData[group]);
  }
  
  const processMonthData = (spTimeLayer, version, activeGroup, data, SpGroups, AllCodes, sortOrder=null) => {
    if (
        !processedData.value[version.value] || 
        processedData.value[version.value][spTimeLayer.value] === undefined || 
        processedData.value[version.value][spTimeLayer.value]['months'] === undefined || 
        processedData.value[version.value][spTimeLayer.value]['months'][activeGroup.value.value] === undefined
    ) {  
        const cellData = data.value[spTimeLayer.value];
        let monthData = [];

        const grp = activeGroup.value.value;
        const theseSp = SpGroups[grp];
        const spToShow = theseSp.filter(sp => cellData[0].hasOwnProperty(`${sp}_M01`));
        const months = {
          "M01" : "Jan",
          "M02" : "Feb",
          "M03" : "Mar",
          "M04" : "Apr",
          "M05" : "May",
          "M06" : "Jun",
          "M07" : "Jul",
          "M08" : "Aug",
          "M09" : "Sep",
          "M10" : "Oct",
          "M11" : "Nov",
          "M12" : "Dec"
        };
        spToShow.forEach(sp => {
            const spObj = { spID: sp, name: AllCodes[sp] };

            Object.entries(months).forEach(([code, monthName]) => {
                const maxVal = cellData.reduce((max, cell) => {
                    const attr = `${sp}_${code}`;
                    return Math.max(max, cell[attr]);
                }, -Infinity);
                spObj[monthName] = maxVal;
            });

            monthData.push(spObj);
        });

        if (sortOrder) {
            monthData.sort((a, b) => sortOrder.indexOf(a.spID) - sortOrder.indexOf(b.spID));
        }

        setProcessedData(version.value, spTimeLayer.value, 'months', activeGroup.value.value, monthData);
        return monthData;
        } 
        else {
            // console.log("loading saved processed mammal month results");
            return processedData.value[version.value][spTimeLayer.value]['months'][activeGroup.value.value];
        }
    };


  // boundary used to test if AOI straddles study area
  // brought in dynamically from local GeoJSON
  const boundary = ref(null)
  onMounted(async () => {
      try {

        let response
        if (import.meta.env.VITE_ISLOCAL === 'true'){
          response = await fetch('/marinemap/ne/boundary.geojson');
          // response = await fetch('/ne-v2-test/boundary.geojson');
        }
        else{
          response = await fetch('/boundary.geojson');
        }

        
        if (!response.ok) {
          throw new Error('Network response was not ok');
        }
        const data = await response.json();
        boundary.value = data;
      } catch (error) {
        console.error('Error loading GeoJSON:', error);
      }
  })


  return {
    appVersion,
    setAppVersion,
    releaseDate,
    setReleaseDate,
    opacity,
    setOpacity,
    queryParams,
    setQueryParams,
    loading,
    setLoading,
    firstPan, 
    setFirstPan,
    tileLayers,
    setTileLayers,
    map,
    setMap,
    mapLoaded, 
    setMapLoaded,
    mapZoom,
    setMapZoom,
    drawZoomWarn,
    setDrawZoomWarn,
    testInBounds,
    layerRootNames,
    userPolygon,
    setUserPolygon,
    activeLayerID,
    setActiveLayerID,
    drawingActive,
    setDrawingActive,
    cellData,
    setCellData,
    getData,
    draw,
    setDraw,
    querying,
    setQuerying,
    siteNames,
    setSiteNames,
    toggleLayer,
    clickAttrs,
    activePane,
    setActivePane,
    printing,
    print,
    zoomToPolygon,
    setLoadedResults,
    styleMap,
    clearMapStyle,
    legendObj,
    setLegend,
    processedData,
    setProcessedData,
    loadSavedProcessedData,
    addSaveProcessedData,
    mapStyleInfo,
    setMapStyleInfo,
    ecos,
    setPolyOffMap,
    polyOffMap,
    dataQuality,
    setDataQuality,
    loadDataByID,
    base64QueryString,
    setBase64QueryString,
    activeSpSpotlight,
    setActiveSpSpotlight,
    activeHabSpotlight,
    setActiveHabSpotlight,
    activeSpGroups,
    setActiveSpGroups,
    activeCoastalHabitat, 
    setActiveCoastalHabitat,
    activeFlagType,
    setActiveFlagType,
    activeFlagValue,
    setActiveFlagValue,
    getNextVersionNumber, 
    firstPanelClicks,
    setFirstPanelClicks,
    processDialData,
    processStackedBarData,
    processMonthData,
    loadingLease,
    setLoadingLease,
    showResultTabLabels,
    setResultTabLabels,
    mapNotes,
    setMapNotes,
    showRestorationProjectPoint,
    clearRestorationProjectPoint,
    showRestorationProjectHighlightPoints,
    clearRestorationProjectHighlightPoints,
    rendering
  };
}
